import { PulseBaseProvider } from '../../../../base-classes';
import { IPulseRequestConfiguration } from "../../../types/PulseInterfaces";
import { GetHurricaneOutlookBulletinActionParameters } from "../../../actions/Hurricane/Outlook/Bulletin/hurricaneOutlookBulletinAction";

const _currentUri = '/api/hur/outlook/v2/bulletin';
const _currentHurricaneOutlookBulletinCacheKey = 'currentHurricaneOutlookBulletin';

export class HurricaneOutlookBulletinProvider extends PulseBaseProvider {
	constructor({ baseUrl, authId, secret, options, logger }: IPulseRequestConfiguration) {
		super(baseUrl, authId, secret, options, logger);
		this.storage.sync[_currentHurricaneOutlookBulletinCacheKey] = this.hurricaneOutlookBulletinSyncer.bind(this);
	}

	async hurricaneOutlookBulletinSyncer(params) {
		const { id, syncParams, resolve, reject } = params;

		const queryParams = {
			...syncParams.stdParameters,
			basin: syncParams.basin
		};

		return await super.syncData(syncParams.key, id, queryParams, _currentUri, resolve, reject, null, syncParams.pulseApi);
	}

	/**
	 * Fetches the observations from storage if they exist and are still valid or fetches new outlook bulletins if needed.
	 * @param apiParameters
	 * -- All of the parameters for the Hurricane Outlook API to be aware of when requesting outlook bulletins
	 * -- API Docs are available here -- http://twoutlookapi-hur.weatherbugsc.com/swagger/index.html
	 */
	async getHurricaneOutlookBulletin(apiParameters: GetHurricaneOutlookBulletinActionParameters) {
		const syncParams = {
			basin: apiParameters.basin
		};
		const id = JSON.stringify(syncParams);

		if (apiParameters.forceRefreshOfCachedData) {
			super.removeFromStorage(_currentHurricaneOutlookBulletinCacheKey, id);
		}
		return await super.loadFromStorage(_currentHurricaneOutlookBulletinCacheKey, id, syncParams);
	}
}
